<ion-header>
  <ion-toolbar></ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <section></section>
</ion-content>
